import { combineReducers } from "redux";
import userReducer from "./reducers/userAuthReducer";
import userProfileReducer from "./reducers/userProfileReducer";
import palleteReducer from "./reducers/pallete.reducer";
import createProductReducer from "./reducers/createProduct.reducer";

const rootReducer = combineReducers({
  userReducer,
  userProfileReducer,
  palleteReducer,
  createProductReducer,
});

export default rootReducer;
